import React, { useState } from "react";
import { TextField, Button, FormHelperText } from "@mui/material";
import axios from "axios";

export const LoginPage = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState(false);

  const handleLogin = () => {
    let data = new FormData();
    data.append("email", email);
    data.append("password", password);

    if (!email && !password) {
      setError(true);
      return;
    }
    axios
      .post("https://api.fabloq.com/user/login/", data)
      .then((res) => {
        let token = res.data.token;
        localStorage.setItem("token", "Token " + token);
        props.setLogin(true);
        props.setStep(1);
        setError(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      });
  };

  return (
    <div className="login-page">
      <div className="login-page-topbar">
        <h1 className="login-page-logo">
          <div className="surface">
            <p className="f-letter">F</p>
            <div className="logo-block"></div>
          </div>
          <span className="insta"></span>
          <span className="api">fabloq</span>
        </h1>
      </div>
      <div className="login-page-content">
        <form>
          <div className="login-page-login-container">
            <p className="login-title">Login</p>
            <TextField
              label="Email"
              className="login-page-textinput"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <TextField
              label="Password"
              variant="outlined"
              className="login-page-textinput"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <FormHelperText error={error}>
              {error ? "Invalid email or password" : ""}
            </FormHelperText>
            <a
              href="https://account.fabloq.com/passwordreset/"
              className="password-change"
            >
              Forgot Password
            </a>
            <Button
              variant="contained"
              className="login-page-button"
              color="primary"
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              Login
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
